import { lazyWithRecovery } from "../utils/lazyWithRecovery";

const Error404 = lazyWithRecovery(() => import("../modules/errors/components/Error404"));
const Error500 = lazyWithRecovery(() => import("../modules/errors/components/Error500"));
const Error401 = lazyWithRecovery(() => import("../modules/errors/components/Error401"));
const Error403 = lazyWithRecovery(() => import("../modules/errors/components/Error403"));
const BuilderPageWrapper = lazyWithRecovery(() => import("../pages/layout-builder/BuilderPageWrapper"));
const Login = lazyWithRecovery(() => import("../modules/auth/views/Login"));
const Logout = lazyWithRecovery(() => import("../modules/auth/views/Logout"));
const ForgotPassword = lazyWithRecovery(() => import("../modules/auth/views/ForgotPassword"));
const Registration = lazyWithRecovery(() => import("../modules/auth/views/Registration"));
const DashboardWrapper = lazyWithRecovery(() => import("../pages/dashboard/DashboardWrapper"));
const Modules = lazyWithRecovery(() => import("../pages/Modules/views/Modules"));
const Users = lazyWithRecovery(() => import("../pages/users/views/Users"));
const Roles = lazyWithRecovery(() => import("../pages/roles/views/Roles"));
const LoginWIthPhone = lazyWithRecovery(() => import("../modules/auth/views/LoginWIthPhone"));
const LoadingPage = lazyWithRecovery(() => import("../pages/loadingPage/LoadingPage"));
const Profile = lazyWithRecovery(() => import("../pages/profile/views/Profile"));
const AddAdminDashboard = lazyWithRecovery(() => import("../pages/adminDashboard/views/AddAdminDashboard"));
const AdminDashboard = lazyWithRecovery(() => import("../pages/adminDashboard/views/AdminDashboard"));
const AddHubsDistrubutors = lazyWithRecovery(() => import("../pages/hubsDistrubutors/views/AddHubsDistrubutors"));
const HubsDistrubutors = lazyWithRecovery(() => import("../pages/hubsDistrubutors/views/HubsDistrubutors"));
const AddCustomers = lazyWithRecovery(() => import("../pages/Customers/views/AddCustomers"));
const Customers = lazyWithRecovery(() => import("../pages/Customers/views/Customers"));
const ViewCustomers = lazyWithRecovery(() => import("../pages/Customers/views/ViewCustomers"));
const AddLocations = lazyWithRecovery(() => import("../pages/Locations/views/AddLocations"));
const Locations = lazyWithRecovery(() => import("../pages/Locations/views/Locations"));
const AddRoutes = lazyWithRecovery(() => import("../pages/Routes/views/AddRoutes"));
const Routes = lazyWithRecovery(() => import("../pages/Routes/views/Routes"));
const AddBrands = lazyWithRecovery(() => import("../pages/Brands/views/AddBrands"));
const Brands = lazyWithRecovery(() => import("../pages/Brands/views/Brands"));
const AddProductCategories = lazyWithRecovery(() => import("../pages/ProductCategories/views/AddProductCategories"));
const ProductCategories = lazyWithRecovery(() => import("../pages/ProductCategories/views/ProductCategories"));
const AddProducts = lazyWithRecovery(() => import("../pages/Products/views/AddProducts"));
const Products = lazyWithRecovery(() => import("../pages/Products/views/Products"));
const AddBanners = lazyWithRecovery(() => import("../pages/Banners/views/AddBanners"));
const Banners = lazyWithRecovery(() => import("../pages/Banners/views/Banners"));
const AppFlashMessage = lazyWithRecovery(() => import("../pages/AppFlashMessage/views/AppFlashMessage"));
const ProductPackageSorting = lazyWithRecovery(
  () => import("../pages/ProductPackageSorting/views/ProductPackageSorting")
);
const AddPromoCodes = lazyWithRecovery(() => import("../pages/PromoCodes/views/AddPromoCodes"));
const PromoCodes = lazyWithRecovery(() => import("../pages/PromoCodes/views/PromoCodes"));

const Reports = lazyWithRecovery(() => import("../pages/Reports/views/Reports"));
const AddCommunications = lazyWithRecovery(() => import("../pages/Communications/views/AddCommunications"));
const Communications = lazyWithRecovery(() => import("../pages/Communications/views/Communications"));
const AddTicket = lazyWithRecovery(() => import("../pages/Ticket/views/AddTicket"));
const Ticket = lazyWithRecovery(() => import("../pages/Ticket/views/Ticket"));
const Settings = lazyWithRecovery(() => import("../pages/Settings/views/Settings"));
const AddCashCollectionReport = lazyWithRecovery(
  () => import("../pages/CashCollectionReport/views/AddCashCollectionReport")
);
const Help = lazyWithRecovery(() => import("../pages/help/views/Help"));
const Cities = lazyWithRecovery(() => import("../pages/City/views/Cities"));
const Area = lazyWithRecovery(() => import("../pages/area/views/Area"));
const SubArea = lazyWithRecovery(() => import("../pages/subArea/views/SubArea"));
const DeliveryUsers = lazyWithRecovery(() => import("../pages/deliveryUser/views/DeliveryUsers"));
const AddPackage = lazyWithRecovery(() => import("../pages/Packages/views/AddPackage"));
const Packages = lazyWithRecovery(() => import("../pages/Packages/views/Packages"));
const ComboPackages = lazyWithRecovery(() => import("../pages/ComboPackages/views/ComboPackages"));
// reports
const OrderSortingReport = lazyWithRecovery(() => import("../pages/Reports/views/orderSortingReport/OrderSortingReport"));
const CashCollectionReport = lazyWithRecovery(
  () => import("../pages/Reports/views/cashCollectionReport/CashCollectionReport")
);
const OrderReport = lazyWithRecovery(() => import("../pages/Reports/views/orderReport/OrderReport"));
const CumulativeSalesReport = lazyWithRecovery(
  () => import("../pages/Reports/views/cummulativeSalesReport/CummulativeSalesReport")
);
const ActivityLogsReport = lazyWithRecovery(() => import("../pages/Reports/views/activityLogsReport/ActivityLogsReport"));
const PackageWiseSaleReport = lazyWithRecovery(
  () => import("../pages/Reports/views/packageWiseSaleReport/PackageWiseSaleReport")
);
const BackOrdersReport = lazyWithRecovery(() => import("../pages/Reports/views/backOrdersReport/BackOrdersReport"));
const CancelOrderReport = lazyWithRecovery(() => import("../pages/Reports/views/cancelOrderReport/CancelOrderReport"));
const CustomerLifeCycleReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerLifeCycleReport/CustomerLifeCycleReport")
);
const CustomerStatementReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerStatementReport/CustomerStatementReport")
);
const CustomerSalesReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerSalesReport/CustomerSalesReport")
);
const CustomerAccountLedger = lazyWithRecovery(
  () => import("../pages/Reports/views/customerAccountLedger/CustomerAccountLedger")
);
const CustomerVacationsReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerVacationsReport/CustomerVacationsReport")
);
const CustomerWalletReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerWalletReport/CustomerWalletReport")
);
const DeliveryExecutiveReferralReport = lazyWithRecovery(
  () => import("../pages/Reports/views/deliveryExecutiveReferralReport/DeliveryExecutiveReferralReport")
);
const FutureOrdersReport = lazyWithRecovery(() => import("../pages/Reports/views/futureOrdersReport/FutureOrdersReport"));
const HubDeliveryReport = lazyWithRecovery(() => import("../pages/Reports/views/hubDeliveryReport/HubDeliveryReport"));
const LowCreditsReport = lazyWithRecovery(() => import("../pages/Reports/views/lowCreditsReport/LowCreditsReport"));
const NewLocationRequestReport = lazyWithRecovery(
  () => import("../pages/Reports/views/newLocationRequestReport/NewLocationRequestReport")
);
const OrderSheetReport = lazyWithRecovery(() => import("../pages/Reports/views/orderSheetReport/OrderSheetReport"));
const PredictiveAnalysisReport = lazyWithRecovery(
  () => import("../pages/Reports/views/predictiveAnalysisReport/PredictiveAnalysisReport")
);
const ReturnsReport = lazyWithRecovery(() => import("../pages/Reports/views/returnsReport/ReturnsReport"));
const ReverseLogisticsReport = lazyWithRecovery(
  () => import("../pages/Reports/views/reverseLogisticsReport/ReverseLogisticsReport")
);
const RLSummaryReport = lazyWithRecovery(() => import("../pages/Reports/views/rLSummaryReport/RLSummaryReport"));
const SubscriptionReport = lazyWithRecovery(() => import("../pages/Reports/views/subscriptionReport/SubscriptionReport"));
const TransactionsReport = lazyWithRecovery(() => import("../pages/Reports/views/transactionsReport/TransactionsReport"));
const VacationsReport = lazyWithRecovery(() => import("../pages/Reports/views/vacationsReport/VacationsReport"));
const SampleReport = lazyWithRecovery(() => import("../pages/Reports/views/sampleReport/SampleReport"));
const TentativeDemandSheetReport = lazyWithRecovery(
  () => import("../pages/Reports/views/tentativeDemandSheet/TentativeDemandSheetReport")
);
const OtpRequest = lazyWithRecovery(() => import("../pages/OtpRequest/views/OtpRequest"));
const AllTransactionsReport = lazyWithRecovery(
  () => import("../pages/Reports/views/allTransactionsReport/AllTransactionsReport")
);
const GenerateInvoiceReport = lazyWithRecovery(
  () => import("../pages/Reports/views/generateInvoice/GenerateInvoiceReport")
);
const PendingOrderDeliveryBoyReport = lazyWithRecovery(
  () => import("../pages/Reports/views/pendingOrderDeliveryBoyReport/PendingOrderDeliveryBoyReport")
);
const ProductSalesCustomerWise = lazyWithRecovery(
  () => import("../pages/Reports/views/productSalesCustomerWise/ProductSalesCustomerWise")
);
const DeliveryBoyRoutes = lazyWithRecovery(() => import("../pages/Reports/views/deliveryBoyRoutes/DeliveryBoyRoutes"));
const FarmVisitRequestReport = lazyWithRecovery(
  () => import("../pages/Reports/views/farmVisitRequestReport/FarmVisitRequestReport")
);
const DeliveryHeatMapReport = lazyWithRecovery(
  () => import("../pages/Reports/views/deliveryHeatMapReport/DeliveryHeatMapReport")
);
const CustomerCallLogsReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerCallLogsReport/CustomerCallLogsReport")
);
const CustomerAddressChangeReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerAddressChangeReport/CustomerAddressChangeReport")
);
const DiscontinuedCustomersReport = lazyWithRecovery(
  () => import("../pages/Reports/views/discontinuedCustomersReport/DiscontinuedCustomersReport")
);
const CustomerReferralReport = lazyWithRecovery(
  () => import("../pages/Reports/views/customerReferralReport/CustomerReferralReport")
);
const PartnerRemunerationReport = lazyWithRecovery(
  () => import("../pages/Reports/views/partnerRemunerationReport/PartnerRemunerationReport")
);
const CronRunReport = lazyWithRecovery(() => import("../pages/Reports/views/cronRunReport/CronRunReport"));
const HubCronDetailsReport = lazyWithRecovery(() => import("../pages/Reports/views/hubCronDetailsReport/HubCronDetails"));
const LowWalletNotificationReport = lazyWithRecovery(
  () => import("../pages/Reports/views/lowWalletNotificationReport/LowWalletNotificationReport")
);
const NotificationReport = lazyWithRecovery(() => import("../pages/Reports/views/notificationReport/NotificationReport"));
//settings
const WalletReason = lazyWithRecovery(() => import("../pages/Settings/views/walletReason/WalletReason"));

const DistributorDashboard = lazyWithRecovery(() => import("../pages/distributorDashboard/views/DistributorDashboard"));
const AddDistributorProducts = lazyWithRecovery(
  () => import("../pages/distributorProducts/views/AddDistributorProducts")
);
const DistributorProducts = lazyWithRecovery(() => import("../pages/distributorProducts/views/DistributorProducts"));
const AddDistributorPackages = lazyWithRecovery(
  () => import("../pages/distributorPackages/views/AddDistributorPackages")
);
const DistributorPackages = lazyWithRecovery(() => import("../pages/distributorPackages/views/DistributorPackages"));
const DistributorReports = lazyWithRecovery(() => import("../pages/distributorReports/views/DistributorReports"));
const ProductSampling = lazyWithRecovery(() => import("../pages/ProductSampling/views/ProductSampling"));
//imports

export const routeComponentMap: { [x: string]: unknown } = {
  Login,
  Registration,
  ForgotPassword,
  DashboardWrapper,
  Error401,
  Error403,
  Error404,
  Error500,
  BuilderPageWrapper,
  Logout,
  Modules,
  Users,
  Roles,
  LoginWIthPhone,
  LoadingPage,
  Profile,
  AddAdminDashboard,
  AdminDashboard,
  AddHubsDistrubutors,
  HubsDistrubutors,
  AddCustomers,
  Customers,
  AddLocations,
  Locations,
  AddRoutes,
  Routes,
  AddBrands,
  Brands,
  AddProductCategories,
  ProductCategories,
  AddProducts,
  Products,
  AddBanners,
  Banners,
  AppFlashMessage,
  ProductPackageSorting,
  AddPromoCodes,
  PromoCodes,
  Reports,
  AddCommunications,
  Communications,
  AddTicket,
  Ticket,
  Settings,
  AddCashCollectionReport,
  Help,
  Cities,
  Area,
  SubArea,
  DeliveryUsers,
  ViewCustomers,
  AddPackage,
  Packages,
  // Reports starts
  ActivityLogsReport,
  BackOrdersReport,
  CancelOrderReport,
  CashCollectionReport,
  CumulativeSalesReport,
  CustomerLifeCycleReport,
  CustomerStatementReport,
  CustomerVacationsReport,
  CustomerWalletReport,
  CustomerSalesReport,
  CustomerAccountLedger,
  DeliveryExecutiveReferralReport,
  FutureOrdersReport,
  HubDeliveryReport,
  LowCreditsReport,
  NewLocationRequestReport,
  OrderReport,
  OrderSheetReport,
  OrderSortingReport,
  PredictiveAnalysisReport,
  ReturnsReport,
  ReverseLogisticsReport,
  RLSummaryReport,
  SubscriptionReport,
  TransactionsReport,
  VacationsReport,
  SampleReport,
  OtpRequest,
  TentativeDemandSheetReport,
  ComboPackages,
  AllTransactionsReport,
  GenerateInvoiceReport,
  PendingOrderDeliveryBoyReport,
  ProductSalesCustomerWise,
  DeliveryBoyRoutes,
  FarmVisitRequestReport,
  DeliveryHeatMapReport,
  CustomerCallLogsReport,
  CustomerAddressChangeReport,
  DiscontinuedCustomersReport,
  CustomerReferralReport,
  PartnerRemunerationReport,
  CronRunReport,
  HubCronDetailsReport,
  PackageWiseSaleReport,
  LowWalletNotificationReport,
  NotificationReport,
  // Reports ends

  //settings starts
  WalletReason,
  //settings ends
  DistributorDashboard,
  AddDistributorProducts,
  DistributorProducts,
  AddDistributorPackages,
  DistributorPackages,
  DistributorReports,
  ProductSampling,
  //exports
};
